import type { TOSSectionData } from "./tos.data";

interface TOSSectionProps {
  section: TOSSectionData;
}

export function TOSSection({ section }: TOSSectionProps) {
  const titleClass = section.isDouble
    ? "legal-section-title double-enum"
    : "legal-section-title";

  return (
    <div className="legal-section">
      <ol start={section.number} className={titleClass}>
        <li className="section-title-label">{section.title}</li>
      </ol>
      <div dangerouslySetInnerHTML={{ __html: section.content }} />
    </div>
  );
}
